// extracted by mini-css-extract-plugin
export var typingIndicator = "_q7-0";